import { initializeApp, FirebaseApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, Auth } from "firebase/auth";
import {
  getFirestore,
  Firestore,
  enableIndexedDbPersistence,
} from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Log Firebase configuration for debugging (without sensitive info)
console.log(
  "Firebase initialization with project:",
  process.env.REACT_APP_FIREBASE_PROJECT_ID
);

// Initialize Firebase with error handling
let app: FirebaseApp;
let auth: Auth;
let db: Firestore;
let googleProvider: GoogleAuthProvider;

try {
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
  db = getFirestore(app);
  googleProvider = new GoogleAuthProvider();

  // Enable offline persistence (safely)
  try {
    enableIndexedDbPersistence(db).catch((err) => {
      if (err.code === "failed-precondition") {
        // Multiple tabs open, persistence can only be enabled in one tab at a time
        console.warn("Firestore persistence failed: Multiple tabs open");
      } else if (err.code === "unimplemented") {
        // The current browser does not support persistence
        console.warn("Firestore persistence not supported in this browser");
      } else {
        console.error("Firestore persistence error:", err);
      }
    });
  } catch (e) {
    console.warn("Could not enable Firestore persistence:", e);
  }
} catch (error) {
  console.error("Firebase initialization error:", error);
  // Create fallbacks for essential Firebase services to prevent app crashes
  app = {} as FirebaseApp;
  auth = { currentUser: null } as Auth;
  db = {} as Firestore;
  googleProvider = {} as GoogleAuthProvider;
}

export { auth, googleProvider, db };
